import React from 'react';
import { Box, CssBaseline, styled } from '@mui/material';
import { MaterialDesignContent, SnackbarProvider } from 'notistack';

import { LoginContainer } from '@paragon/login-tools';
import { ParagonHeader } from '@paragon/material';
import { Notifier, NotifierDialog } from '@paragon/notification-tools';
import { UserDropdown } from '@paragon/themes';

import { startApp } from '../actions/startApp';
import { Content } from './Content';
import { DialogContainer } from './dialogs/DialogContainer';
import { useAppDispatch } from './hooks';
import { KeyboardListener } from './KeyboardListener';

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent': { color: 'white' },
}));

export function RootComponent() {
  const dispatch = useAppDispatch();

  return (
    <>
      <CssBaseline />
      <SnackbarProvider
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        maxSnack={3}
        Components={{
          default: StyledMaterialDesignContent,
          success: StyledMaterialDesignContent,
          error: StyledMaterialDesignContent,
          warning: StyledMaterialDesignContent,
          info: StyledMaterialDesignContent,
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', position: 'fixed', top: 0 }}
        >
          <Notifier />
          <NotifierDialog />
          <LoginContainer
            requirePermission="schedule-access"
            onLogIn={() => {
              dispatch(startApp());
            }}
          >
            <Box
              sx={{
                flexGrow: 1,
                height: 431,
                zIndex: 1,
                overflow: 'hidden',
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
              }}
            >
              <KeyboardListener />
              <ParagonHeader text="Paragon Schedule" clientName="schedule">
                <UserDropdown />
              </ParagonHeader>
              <Content />

              <DialogContainer />
            </Box>
          </LoginContainer>
        </Box>
      </SnackbarProvider>
    </>
  );
}
